import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FleetConditionWidgetComponent } from './components/fleet-condition-widget/fleet-condition-widget.component';
// import { FusionChartsModule } from 'angular-fusioncharts';
import { WidgetsService } from './widgets.service';
//import { FusionChartsModule } from 'angular-fusioncharts';
//import FusionCharts from 'fusioncharts/core';
// Fusion Charts
// import * as FusionCharts from 'fusioncharts';
//import Column2D from 'fusioncharts/viz/column2d';
///import doughnut3d from 'fusioncharts/viz/doughnut3d';
//import msarea from 'fusioncharts/viz/msarea';
//import stackedcolumn2d from 'fusioncharts/viz/stackedcolumn2d';
//import msstackedcolumn2d from 'fusioncharts/viz/msstackedcolumn2d';
//import FusionTheme from 'fusioncharts/themes/es/fusioncharts.theme.fusion';
//import scrollstackedcolumn2d from 'fusioncharts/viz/scrollstackedcolumn2d';
//import ZuneTheme from 'fusioncharts/themes/es/fusioncharts.theme.zune';
import { MaterialModule } from '../../shared/material.module';
import { InspectionsPerformedWidgetComponent } from './components/inspections-performed-widget/inspections-performed-widget.component';
import { CostOfRepairsMonthlyWidgetComponent } from './components/cost-of-repairs-monthly-widget/cost-of-repairs-monthly-widget.component';
import { ComponentsOnEvalWidgetComponent } from './components/components-on-eval-widget/components-on-eval-widget.component';
//import * as Charts from 'fusioncharts/fusioncharts.charts';

//FusionChartsModule.fcRoot(FusionCharts, FusionTheme, stackedcolumn2d, Column2D, doughnut3d, msarea, ZuneTheme, msstackedcolumn2d, scrollstackedcolumn2d );

import { InspectionsDueWidgetComponent } from './components/inspections-due-widget/inspections-due-widget.component';
import { DatePipe } from '@angular/common';
import { WidgetsEnlargedComponentComponent } from './components/widgets-enlarged-component/widgets-enlarged-component.component';

import * as FusionCharts from "fusioncharts";
import * as Charts from "fusioncharts/fusioncharts.charts";
import * as FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import { FusionChartsModule } from "angular-fusioncharts";

FusionChartsModule.fcRoot(FusionCharts, Charts, FusionTheme);

@NgModule({
    imports: [
        CommonModule,
        FusionChartsModule.forRoot(FusionCharts, Charts),
        MaterialModule
    ],
    declarations: [
        FleetConditionWidgetComponent,
        InspectionsPerformedWidgetComponent,
        CostOfRepairsMonthlyWidgetComponent,
        ComponentsOnEvalWidgetComponent,
        InspectionsDueWidgetComponent,
        WidgetsEnlargedComponentComponent,
    
    ],
    exports: [
        FleetConditionWidgetComponent,
        InspectionsPerformedWidgetComponent,
        CostOfRepairsMonthlyWidgetComponent,
        ComponentsOnEvalWidgetComponent,
        InspectionsDueWidgetComponent,
    ],
    providers: [
        WidgetsService,
        DatePipe
    ]
})
export class WidgetsModule { }
